import {StateToken} from '@ngxs/store';
import {FinancialStatementModel} from './financial-statement.model';

export const FINANCIAL_STATEMENT_STATE_TOKEN = new StateToken<FinancialStatementModel>('financialstatement');
